export default __webpack_public_path__ + "static/media/dzieci.81fcef7b.jpg";